<div
  class="spot-link"
  [title]="text.open_dialog"
  (click)="handleClick($event)"
  (keydown.enter)="handleClick($event)"
  (keydown.space)="handleClick($event)"
  role="button"
  tabindex="0"
  data-test-selector="static-attribute-help-text--icon"
>
  <svg question-icon size="small" />
</div>
